/**
 * 自由职业者列表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-if="roleId === 2"
        :to="{ path: '/task/professionalList' }"
        >用工中心</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="姓名 :">
            <el-input
              size="small"
              v-model="formInline.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="手机号 :">
            <el-input
              size="small"
              v-model="formInline.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="证件类型 :">
            <el-select
              size="small"
              v-model="formInline.idType"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in idType_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="证件号 :">
            <el-input
              size="small"
              v-model="formInline.idNumber"
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="认证状态 :">
            <el-select
              size="small"
              v-model="formInline.verificationStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in verificationStatus_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="收款账号 :">
            <el-input
              size="small"
              v-model="formInline.receiveAccount"
              placeholder="请输入收款账号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="签约状态 :">
            <el-select
              size="small"
              v-model="formInline.signStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in signStatus_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="签约时间 : ">
            <el-date-picker
              size="small"
              v-model="formInline.sign_date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button
        size="small"
        type="primary"
        @click="uploadVisible = true"
        v-if="shouldShowButton('upload')"
        >批量导入</el-button
      >
      <el-button
        size="small"
        @click="batchSign"
        v-if="shouldShowButton('batchSign')"
        >批量签约</el-button
      >
      <el-button
        size="small"
        @click="exportdata"
        v-if="shouldShowButton('exportData')"
        >导出数据</el-button
      >
      <el-button
        size="small"
        @click="exportagreement"
        v-if="shouldShowButton('exportAgreement')"
        >导出协议</el-button
      >
      <el-button
        size="small"
        @click="exportpath"
        v-if="shouldShowButton('exportPath')"
        >导出记录</el-button
      >
      <el-button
        size="small"
        @click="onContractMigration"
        v-if="shouldShowButton('contractMigration')"
        >导入协议</el-button
      >
      <el-button
        size="small"
        @click="onContractMigrationLog"
        v-if="shouldShowButton('contractMigrationLog')"
        >导入记录</el-button
      >
    </div>

    <!--列表-->
    <el-table
      ref="table"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column fixed prop="freelancerName" label="姓名" min-width="80">
      </el-table-column>
      <el-table-column
        prop="identityDocumentType"
        label="证件类型"
        min-width="80"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.identityDocumentType == 1 ? "身份证" : "护照" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="identityDocumentNumber"
        label="证件号"
        min-width="170"
      >
        <template slot-scope="scope">
          <div @click="xhrGetidentityDocumentNumber(scope.row.freelancerId)">
            <span style="color: #409eff; cursor: pointer">{{
              scope.row.identityDocumentNumber
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="identityPhoto"
        label="证件照"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" min-width="110">
      </el-table-column>
      <el-table-column
        prop="receiveAccount"
        label="收款账号"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="verificationStatusStr"
        label="认证状态"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getVerifiStatusColor(scope.row.verificationStatus),
            }"
            >{{ scope.row.verificationStatusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="signStatusStr"
        label="签约状态"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getSignStatusColor(scope.row.signStatus),
            }"
            >{{ scope.row.signStatusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="签约协议" min-width="90">
        <template v-slot:default="scope">
          <el-button type="text" @click="xhrGetFreelancerProtocol(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="contractSignAt"
        label="签约时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        min-width="150"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.verificationStatus !== 3">
            <el-button
              size="small"
              type="primary"
              plain
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <el-dialog
      :title="uploadDialog.title"
      :visible.sync="uploadDialog.visible"
      @open="uploadDialogOpen"
      width="500px"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="signForm"
        :rules="rules"
        ref="signForm"
      >
        <div
          style="
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
          "
        >
          <el-button
            size="small"
            style="margin: 0 20px"
            @click="exampleDownload"
            >模板下载</el-button
          >
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :on-remove="handleSignRemove"
            :on-change="fileOnChange"
            :file-list="signFileList"
            :auto-upload="false"
          >
            <el-button size="small" slot="trigger" type="primary"
              >选取文件</el-button
            >
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitSignTempForm('signForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="500px"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="备注" prop="remark">
          <el-input
            size="small"
            v-model="editForm.remark"
            auto-complete="off"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="查看" :visible.sync="checkVisible" width="500px">
      <div style="width: 100%; height: 200px">
        <el-image :src="pic_1" style="width: 48%; height: 100%"> </el-image>
        <el-image :src="pic_2" style="width: 48%; height: 100%"> </el-image>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="uploadVisible" width="500px">
      <el-upload
        class="upload-demo"
        ref="upload"
        action=""
        :on-remove="handleRemove"
        :on-change="file_on_change"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button slot="trigger" type="primary">选取文件</el-button>
        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
      </el-upload>
      <el-image
        src="static/home/zip_info.jpg"
        style="width: 450px; height: auto; margin-top: 20px"
      ></el-image>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upload_file">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="editDetailTitle"
      :visible.sync="editDetailVisible"
      width="700px"
      @close="closeDialog"
    >
      <el-form
        label-width="95px"
        :model="editDetailForm"
        :rules="rules"
        ref="editDetailForm"
      >
        <!-- 姓名和证件类型 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名：" prop="freelancerName">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.freelancerName"
                auto-complete="off"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="mobile">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.mobile"
                auto-complete="off"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证件类型：" prop="identityDocumentType">
              <el-select
                style="width: 220px"
                size="small"
                v-model="editDetailForm.identityDocumentType"
                placeholder="请选择"
              >
                <el-option
                  v-for="(val, index) in idType_list"
                  :label="val.label"
                  :value="val.value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号：" prop="identityDocumentNumber">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.identityDocumentNumber"
                auto-complete="off"
                placeholder="请输入证件号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收款账号：" prop="receiveAccount">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.receiveAccount"
                auto-complete="off"
                placeholder="请输入收款账号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditDetailDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitEditDetailForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="协议导入"
      :visible.sync="contractMigrationVisible"
      width="80%"
      @close="closeContractMigrationDialog"
    >
      <el-form
        :inline="true"
        :model="formInline"
        label-width="65px"
        style="padding-left: 15px; margin-bottom: 15px"
      >
        <el-form-item label="服务商 :">
          <el-input
            size="small"
            v-model="formInlineDialog.distributeCompanyName"
            placeholder="请输入服务商"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名 :">
          <el-input
            size="small"
            v-model="formInlineDialog.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="证件号 :">
          <el-input
            size="small"
            v-model="formInlineDialog.idNumber"
            placeholder="请输入证件号"
          ></el-input>
        </el-form-item>

        <el-form-item label-width="30px">
          <el-button
            size="small"
            type="primary"
            @click="fetchAllAcountFreelancer()"
            >搜索</el-button
          >
          <el-button size="small" @click="resetDialogSearch()">清空</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        size="small"
        height="500"
        :data="migrationListData"
        highlight-current-row
        v-loading="migrationLoading"
        element-loading-text="拼命加载中"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          prop="freelancerName"
          label="姓名"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="distributeCompanyName"
          label="服务商"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="identityDocumentTypeStr"
          label="证件类型"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="identityDocumentNumber"
          label="证件号"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div
              class="ellipsis-text"
              @click="xhrGetidentityDocumentNumber(scope.row.freelancerId)"
            >
              <span style="color: #409eff; cursor: pointer">{{
                scope.row.identityDocumentNumber
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="receiveAccount"
          label="收款账号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="verificationStatusStr"
          label="认证状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="signStatusStr"
          label="签约状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="签约协议" show-overflow-tooltip>
          <template v-slot:default="scope">
            <el-button type="text" @click="xhrGetFreelancerProtocol(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="contractSignAt"
          label="签约时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.remark"
              placement="bottom"
              effect="light"
            >
              <span class="ellipsis">{{ scope.row.remark }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        v-bind:child-msg="pageparmDialog"
        @callFather="callDialogFather"
      ></Pagination>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="toggleSelection()">取消选择</el-button>
        <el-button size="small" type="primary" @click="onMigrationAll()"
          >导入全部</el-button
        >
        <el-button size="small" type="primary" @click="onMigrationSelect()"
          >导入选中</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  freelancerslist,
  editremarkfreelancers,
  checkphoto,
  updateFreelancer,
  export_agreement,
  exportfreelancers,
  uploadzip,
  deleteFreelancer,
  batchSignUpload,
  batchSignTemplate,
  getAllAccountFreelancers,
  migrationFreelancers,
} from "../../api/userMG";
import { MessageBox } from "element-ui";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      migrationListData: [],
      migrationLoading: false,
      multipleSelection: [],
      contractMigrationVisible: false,
      roleId: 0,
      verificationStatus_list: [
        {
          label: "认证失败",
          value: 1,
        },
        {
          label: "未认证",
          value: 2,
        },
        {
          label: "认证成功",
          value: 3,
        },
        {
          label: "待审核",
          value: 4,
        },
        {
          label: "人脸识别成功",
          value: 5,
        },
        {
          label: "未识别",
          value: 6,
        },
      ],
      isPortraitPhoto_list: [],
      isIdentityPhoto_list: [],
      idType_list: [
        {
          label: "身份证",
          value: 1,
        },
        {
          label: "护照",
          value: 2,
        },
        {
          label: "台湾通行证(台胞证)",
          value: 3,
        },
        {
          label: "港澳通行证(回乡证)",
          value: 4,
        },
      ],
      signStatus_list: [
        {
          label: "待签约",
          value: 0,
        },
        {
          label: "签约失败",
          value: 1,
        },
        {
          label: "拒签",
          value: 2,
        },
        {
          label: "签约成功",
          value: 3,
        },
        {
          label: "待人工审核",
          value: 4,
        },
        {
          label: "签约失效",
          value: 5,
        },
      ],
      status_list: [
        {
          label: "待录用",
          value: 0,
        },
        {
          label: "已录用",
          value: 1,
        },
        {
          label: "已拒绝",
          value: 2,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      uploadDialog: {
        title: "上传自由职业者",
        visible: false,
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      checkVisible: false, //控制编辑页面显示与隐藏
      uploadVisible: false,
      editDetailTitle: "修改",
      editDetailVisible: false,
      editDetailForm: {
        id: "",
        freelancerName: "",
        mobile: "",
        identityDocumentType: "",
        identityDocumentNumber: "",
        receiveAccount: "",
      },

      title: "添加",
      editForm: {
        remark: "",
        freelancerId: "",
        token: localStorage.getItem("logintoken"),
      },
      signForm: {},
      // rules表单验证
      rules: {
        freelancerName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        identityDocumentType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        identityDocumentNumber: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号码格式",
            trigger: "blur",
          },
        ],
        receiveAccount: [
          { required: true, message: "请输入收款账号", trigger: "blur" },
        ],
      },
      fileList: [],
      signFileList: [],
      pic_1: "",
      pic_2: "",
      formInline: {
        page: 1,
        pageSize: 10,
        name: "",
        idNumber: "",
        mobile: "",
        idType: "",
        verificationStatus: "",
        receiveAccount: "",
        signStatus: "",
        signAtStartDate: "",
        signAtEndDate: "",
        sign_date: [],
        isPortraitPhoto: "",
        isIdentityPhoto: "",
        updatedStartDate: "",
        updatedEndDate: "",
      },

      formInlineDialog: {
        page: 1,
        pageSize: 10,
        name: "",
        idNumber: "",
        distributeCompanyName: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      pageparmDialog: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId = JSON.parse(localStorage.getItem("user_info")).roleId;
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getSignStatusColor(status) {
      // 根据状态值返回对应的颜色
      switch (status) {
        case 0:
          return "#409EFF"; // 蓝色
        case 3:
          return "#67C23A"; // 绿色
        case 5:
          return "#909399"; // 灰色
        case 1:
        case 2:
          return "#F56C6C"; // 红色
        case 4:
          return "#E6A23C"; // 黄色
        default:
          return "#303133"; // 默认黑色
      }
    },

    getVerifiStatusColor(status) {
      // 根据状态值返回对应的颜色
      switch (status) {
        case 2:
          return "#409EFF"; // 蓝色
        case 3:
          return "#67C23A"; // 绿色
        case 6:
          return "#909399"; // 灰色
        case 1:
          return "#F56C6C"; // 红色
        case 5:
          return "#E6A23C"; // 黄色
        default:
          return "#303133"; // 默认黑色
      }
    },
    shouldShowButton(buttonType) {
      if (this.roleId === 2) {
        // 角色为2时不显示任何按钮
        return false;
      }
      // 其他角色显示所有按钮
      return true;
    },
    fetchAllAcountFreelancer() {
      getAllAccountFreelancers(this.formInlineDialog)
        .then((res) => {
          this.migrationLoading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.migrationListData = res.data.items;
            // 分页赋值
            this.pageparmDialog.page = res.data.page;
            this.pageparmDialog.pageSize = res.data.pageSize;
            this.pageparmDialog.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.migrationLoading = false;
          this.$message.error(err);
        });
    },
    exportpath() {
      this.$router.push({ path: "/task/exportList" });
    },
    onContractMigration() {
      this.migrationListData = [];
      this.migrationLoading = true;
      this.fetchAllAcountFreelancer();
      this.contractMigrationVisible = true;
    },
    onContractMigrationLog() {
      this.$router.push({ path: "/task/contractMigrationLog" });
    },
    closeContractMigrationDialog() {
      this.contractMigrationVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    onMigrationAll() {
      this.$confirm("确定导入全部职业者?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          migrationFreelancers({
            sourceList: [],
            isAll: 1,
            totalNum: this.pageparmDialog.total,
            name: this.formInlineDialog.name,
            idNumber: this.formInlineDialog.idNumber,
            distributeCompanyName: this.formInlineDialog.distributeCompanyName,
          }) // 传递选中的任务
            .then((res) => {
              if (res.msg === "success") {
                this.$message.success(
                  "自由职业者正在导入中，请在导入记录中查看"
                );
                this.closeContractMigrationDialog();
                this.onContractMigrationLog();
              } else {
                this.$message.error(res.msg || "导入失败，请重试");
              }
            })
            .catch((error) => {
              this.$message.error("网络错误，请稍后重试");
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    onMigrationSelect() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.error("请选择要导入的自由职业者");
        return;
      }

      this.$confirm("确定导入选中职业者?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id);
          migrationFreelancers({
            sourceList: ids,
            isAll: 0,
            totalNum: ids.length,
            name: this.formInlineDialog.name,
            idNumber: this.formInlineDialog.idNumber,
            distributeCompanyName: this.formInlineDialog.distributeCompanyName,
          }) // 传递选中的任务
            .then((res) => {
              if (res.msg === "success") {
                this.$message.success(
                  "自由职业者正在导入中，请在导入记录中查看"
                );
                this.closeContractMigrationDialog();
                this.onContractMigrationLog();
              } else {
                this.$message.error(res.msg || "导入失败，请重试");
              }
            })
            .catch((error) => {
              this.$message.error("网络错误，请稍后重试");
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    upload_file() {
      if (this.fileList.length > 0) {
        const formData = new FormData();
        formData.append("file", this.fileList[0].raw);
        uploadzip(formData)
          .then((res) => {
            this.loading = false;
            if (res.msg == "success") {
              this.uploadVisible = false;
              this.$message.success(
                "自由职业者身份证正在导入中，请在导入记录中查看"
              );
              this.onContractMigrationLog();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.$message({
          type: "error",
          message: "请上传文件",
        });
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    file_on_change(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
    },
    uploadDialogOpen() {
      this.signFileList = [];
    },
    exampleDownload() {
      batchSignTemplate()
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    handleSignRemove(file, fileList) {
      console.log(file, fileList);
    },
    fileOnChange(file, signFileList) {
      if (signFileList.length > 1) {
        signFileList.splice(0, 1);
      }
      this.signFileList = signFileList;
    },
    batchSign() {
      this.uploadDialog.visible = true;
    },
    submitSignTempForm() {
      if (this.signFileList.length == 0) {
        this.$message({
          type: "error",
          message: "请先完善信息！",
        });
        return;
      }
      this.loading = true;

      const formData = new FormData();
      formData.append("file", this.signFileList[0].raw);
      batchSignUpload(formData)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.uploadDialog.visible = false;
            this.getdata(this.formInline);
            this.$message({
              type: "success",
              message: "操作成功",
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    exportdata() {
      MessageBox.confirm(
        "您想导出所有自由职业者信息还是仅导出选中的数据？",
        "提示",
        {
          confirmButtonText: "所有数据",
          cancelButtonText: "选中数据",
          type: "warning",
          distinguishCancelAndClose: true,
        }
      )
        .then(() => {
          exportfreelancers({})
            .then((res) => {
              this.loading = false;
              if (res.msg != "success") {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              } else {
                this.$router.push({ path: "/task/exportList" });
                this.$message({
                  type: "success",
                  message: "请查看导出记录",
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("导出错误");
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let freelancerIds = [];
            const selectedRows = this.$refs.table.selection;
            selectedRows.forEach((row) => {
              freelancerIds.push(row.id);
            });
            if (freelancerIds.length > 0) {
              const params = {
                freelancerIds: freelancerIds.join(","),
              };

              exportfreelancers(params)
                .then((res) => {
                  this.loading = false;
                  if (res.msg != "success") {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  } else {
                    this.$router.push({ path: "/task/exportList" });
                    this.$message({
                      type: "success",
                      message: "请查看导出记录",
                    });
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  this.$message.error("导出错误");
                });
            } else {
              this.$message.warning("请选择要导出的数据");
            }
          }
        });
    },
    exportagreement() {
      MessageBox.confirm(
        "您想导出所有自由职业者协议还是仅导出选中的协议？",
        "提示",
        {
          confirmButtonText: "所有协议",
          cancelButtonText: "选中协议",
          type: "warning",
          distinguishCancelAndClose: true,
        }
      )
        .then(() => {
          export_agreement({})
            .then((res) => {
              this.loading = false;
              if (res.msg != "success") {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              } else {
                this.$router.push({ path: "/task/exportList" });
                this.$message({
                  type: "success",
                  message: "请查看导出记录",
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("导出错误");
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let freelancerIds = [];
            const selectedRows = this.$refs.table.selection;
            selectedRows.forEach((row) => {
              freelancerIds.push(row.id);
            });
            const params = {
              freelancerIds: freelancerIds.join(","),
            };
            if (freelancerIds.length > 0) {
              export_agreement(params)
                .then((res) => {
                  this.loading = false;
                  if (res.msg != "success") {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  } else {
                    this.$router.push({ path: "/task/exportList" });
                    this.$message({
                      type: "success",
                      message: "请查看导出记录",
                    });
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  this.$message.error("导出错误");
                });
            } else {
              this.$message.warning("请选择要导出的数据");
            }
          }
        });
    },
    xhrGetidentityDocumentNumber(id) {
      checkphoto({ identityDocumentNumber: id })
        .then((res) => {
          this.loading = false;
          if (res.code != 0) {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.pic_1 = res.data.identityPhoto1Url;
            this.pic_2 = res.data.identityPhoto2Url;
            this.checkVisible = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    xhrGetFreelancerProtocol(row) {
      if (!row.contractAgreement) {
        this.$message.error("自由职业者服务协议未生成，请联系管理员");
        return;
      }

      if (row.signStatus != 3) {
        this.$message.error("自由职业者签约未完成，请签约成功后查看");
        return;
      }

      window.open(row.contractAgreement, "_blank");
    },
    // 获取公司列表
    getdata(parameter) {
      parameter.signAtStartDate = parameter.sign_date[0] || "";
      parameter.signAtEndDate = parameter.sign_date[1] || "";

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      freelancerslist(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("菜单加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    callDialogFather(parm) {
      this.formInlineDialog.page = parm.page;
      this.formInlineDialog.pageSize = parm.pageSize;

      this.migrationLoading = true;
      // 获取数据
      this.fetchAllAcountFreelancer();
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        name: "",
        idNumber: "",
        mobile: "",
        idType: "",
        verificationStatus: "",
        receiveAccount: "",
        isPortraitPhoto: "",
        isIdentityPhoto: "",
        signStatus: "",
        updatedStartDate: "",
        updatedEndDate: "",
        signAtStartDate: "",
        signAtEndDate: "",
        sign_date: [],
        update_date: [],
      };
      this.getdata(this.formInline);
    },

    resetDialogSearch() {
      const page = this.formInlineDialog.page;
      const pageSize = this.formInlineDialog.pageSize;
      this.formInlineDialog = {
        page: page,
        pageSize: pageSize,
        name: "",
        idNumber: "",
        distributeCompanyName: "",
      };
      this.fetchAllAcountFreelancer();
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          editremarkfreelancers(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },

    submitEditDetailForm() {
      this.$refs.editDetailForm.validate((valid) => {
        if (valid) {
          updateFreelancer(this.editDetailForm).then((res) => {
            this.loading = false;
            if (res.msg == "success") {
              this.editDetailVisible = false;
              this.getdata(this.formInline);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.uploadDialog.visible = false;
    },
    handleEdit(row) {
      this.editDetailVisible = true;
      this.editDetailForm.id = row.id;
      this.editDetailForm.freelancerName = row.freelancerName;
      this.editDetailForm.identityDocumentType = row.identityDocumentType;
      this.editDetailForm.receiveAccount = row.receiveAccount;
      this.editDetailForm.identityDocumentNumber = row.identityDocumentNumber;
      this.editDetailForm.mobile = row.mobile;
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let parameter = {
            id: row.id,
          };
          deleteFreelancer(parameter).then((res) => {
            if (res.msg == "success") {
              this.getdata(this.formInline);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    closeEditDetailDialog() {
      this.editDetailVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.dialog-table {
  margin-top: 20px;
  border: 1px solid #ebeef5;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.mb-4 {
  margin-top: 16px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/task/professionalList.vue